import React from "react";
import { cn } from "./cn";

/**
 * Bun chat bubble (Inbox, Parabot, client messages). Spec: Component Library
 * "Client message + internal note". Their side sits left on mist; our side
 * sits right on the blue wash; the corner nearest the avatar stays tight.
 *
 *   <MessageBubble avatar={<Avatar size="sm" name="Maya Patel" />}>
 *     Should we bump the 529 monthly to $600?
 *   </MessageBubble>
 *   <MessageBubble me avatar={<Avatar size="sm" tone="ink" initials="AR" />}>
 *     Great timing. Let's cover it at 10:30.
 *   </MessageBubble>
 */
export default function MessageBubble({ me, avatar, variant, className, children, footer }) {
  const conversation = variant === 'conversation';
  if (conversation) {
    return <div className={cn('flex gap-[14px] font-instrument', me && 'flex-row-reverse', className)}>
      {avatar}
      <div className={cn('min-w-0', me ? 'max-w-[92%] md:max-w-[80%]' : 'flex-1')}>
        <div className={cn('min-w-0 text-bun-body font-book text-bun-text', me && 'rounded-[18px_18px_6px_18px] bg-bun-chat-bubble px-4 py-3')}>
          {children}
        </div>
        {footer && <div className={cn('mt-2', me && 'pr-1 text-right')}>{footer}</div>}
      </div>
    </div>;
  }
  return (
    <div className={cn("flex gap-[9px] font-instrument", me && "flex-row-reverse", className)}>
      {avatar}
      <div
        className={cn(
          "min-w-0 text-bun-body font-book text-bun-text",
          'px-3 py-[9px] max-w-[85%]',
          me ? "bg-bun-wash rounded-[12px_12px_4px_12px]" : "bg-bun-mist rounded-[12px_12px_12px_4px]"
        )}
      >
        {children}
      </div>
    </div>
  );
}
